exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reduce-line-height {\n  line-height: 1.5rem; }\n\n.uppercase {\n  text-transform: uppercase; }\n\n.scale-out-for-print {\n  zoom: 0.7; }\n\n.reduce-line-for-print {\n  line-height: 0.8rem; }\n\n.reduce-line-for-factsheet {\n  line-height: 1rem; }\n\n.header-for-pdf {\n  font-size: 0.8rem;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #231f20; }\n\n.header-for-pdf p {\n    font-weight: normal; }\n\n.header-for-factSheet {\n  font-size: 1.1rem;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #231f20; }\n\n.header-for-factSheet p {\n    font-weight: normal; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/financial-header/financial-header.component.scss
// module id = ../../../../../src/app/securities-level/financial-header/financial-header.component.scss
// module chunks = main